import { Button } from "@/components/ui/Button";

export function FlashInfo({ message, onDismiss }: { message: string; onDismiss: () => void }) {
  return (
    <div style={{ position: "fixed", top: 16, left: "50%", transform: "translateX(-50%)", zIndex: 10000, maxWidth: 420, width: "100%" }}>
      <div style={{
        display: "flex", alignItems: "center", gap: 10,
        padding: "10px 14px", borderRadius: 8, fontSize: 13,
        background: "var(--accent-surface)",
        border: "1px solid var(--accent-surface)",
        color: "var(--accent)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
      }}>
        <span style={{ fontSize: 16, flexShrink: 0 }}>{"ℹ"}</span>
        <span style={{ flex: 1 }}>{message}</span>
        <Button
          variant="ghost"
          size="icon"
          onClick={onDismiss}
          className="h-auto w-auto p-0 px-0.5 text-base text-current hover:bg-transparent flex-shrink-0"
        >
          &times;
        </Button>
      </div>
    </div>
  );
}
